<template>
  <div class="mainNav">
    <div class="container">
      <ul class="navList">
        <li
          :class="`navItem ${$route.path === '/intro' ? 'active' : ''}`"
          @click="handleRedirect('intro')"
        >
          平台介绍
        </li>
        <li
          :class="
            `navItem ${
              $route.path === '/news/list' || $route.path === '/news/detail'
                ? 'active'
                : ''
            }`
          "
          @click="handleRedirect('news/list?type=0')"
        >
          新闻中心
        </li>
        <li
          :class="
            `navItem ${$route.path === '/personalServices' ? 'active' : ''}`
          "
          @click="handleRedirect('personalServices')"
        >
          个人服务
        </li>
        <li
          :class="
            `navItem ${$route.path === '/educationalServices' ? 'active' : ''}`
          "
          class="navItem"
          @click="handleRedirect('educationalServices')"
        >
          教育机构服务
        </li>
        <li
          :class="
            `navItem ${$route.path === '/employerServices' ? 'active' : ''}`
          "
          class="navItem"
          @click="handleRedirect('employerServices')"
        >
          用人单位服务
        </li>
        <li
          :class="
            `navItem ${$route.path === '/socialGroupServices' ? 'active' : ''}`
          "
          class="navItem"
          @click="handleRedirect('socialGroupServices')"
        >
          社会团体服务
        </li>
        <li
          :class="
            `navItem ${
              $route.path === '/CooperationProjectSupportServices'
                ? 'active'
                : ''
            }`
          "
          class="navItem"
          @click="handleRedirect('CooperationProjectSupportServices')"
        >
          合作项目支撑服务
        </li>
      </ul>
    </div>
    <div class="dialog" v-if="isBuilding">
      <div class="main">
        <div class="dialog_content">正在建设中</div>
        <div><button @click="isBuilding = false">确定</button></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isBuilding: false
    };
  },
  methods: {
    handleRedirect(path) {
      this.$router.push("/" + path);
    }
  }
};
</script>

<style scoped lang="scss">
.mainNav {
  width: 100%;
  background: rgba(0, 0, 0, 0.27);
  background-color: #29447c;
  color: rgba(255, 255, 255, 0.73);
  font-size: 18px;
  font-family: PingFang SC;
  .navList {
    display: flex;
    justify-content: space-between;
    align-items: center;
    list-style: none;
    .navItem {
      width: 178px;
      float: left;
      //   padding: 19px 26px 19px 23px;
      padding: 26px 0;
      display: block;
      box-sizing: content-box;
      cursor: pointer;
      text-decoration: none;
      font-size: 16px;
      text-align: center;
      &:hover {
        background-color: #1a3671;
      }
    }
    .active {
      background-color: #1a3671;
    }
  }
}
.dialog {
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  z-index: 2;
  .main {
    margin: 0 auto;
    border-radius: 4px;
    background: #fff;
    width: 300px;
    height: 150px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    font-size: 18px;
    .dialog_content {
      color: #000;
    }
    button {
      outline: none;
      width: 100px;
      background-color: #3a61b1;
      border: 1px solid #666;
      border-radius: 4px;
      padding: 5px;
      cursor: pointer;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue